import React from "react";
import Header from "../../layout/Header";
import LeftBar from "../leftBar/LeftBar";
import DestinationBar from "./sections/DestinationBar";

export default function DestinationDetails() {
  return (
    <>
      <section className="font-soehne">
        <Header />
        <section className="lg:py-20 py-12 xl:w-5/6 w-11/12 mx-auto lg:grid lg:grid-cols-12">
          <LeftBar />
          <DestinationBar />
        </section>
      </section>
    </>
  );
}
